<template>
  <v-layout>
    <v-app-bar elevation="0" class="border-b px-4">
      <v-app-bar-nav-icon
        v-if="isNavbarActive"
        variant="text"
        @click.stop="drawer = !drawer"
        class="mx-0"
      ></v-app-bar-nav-icon>
      <v-toolbar-title @click="navigateTo('/pembelajaran-wajib')">
        <v-img height="48px" width="106px" src="/images/logo.png"
      /></v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.display.mdAndUp">
        <AccountBelajarWajib />
        <v-menu width="254">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-chevron-down"
              variant="text"
              v-bind="props"
            ></v-btn>
          </template>
          <v-list>
            <v-list-item title="Keluar" @click="logoutBelajarWajib">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout"></v-icon>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <v-menu v-else width="254">
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"></v-btn>
        </template>
        <v-list>
          <AccountBelajarWajib class="mb-2" />
          <v-divider></v-divider>
          <v-list-item title="Keluar" @click="logoutBelajarWajib">
            <template v-slot:prepend>
              <v-icon icon="mdi-logout"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-if="isNavbarActive"
      v-model="drawer"
      :location="$vuetify.display.mobile ? 'bottom' : 'left'"
      class="border-0 bg-white pt-4"
      width="300"
      elevation="3"
    >
      <v-list color="blue-accent-4" class="mb-4">
        <v-list-item
          class="px-7"
          v-for="(link, linkId) in navbarLink"
          :key="linkId"
          :prepend-icon="link.icon"
          :title="link.name"
          :value="link.name"
          :to="link.to"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="text-center pa-2 text-caption">
          Portal Pembelajaran Wajib
          <div class="text-medium-emphasis">
            Lembaga Administrasi Negara — {{ new Date().getFullYear() }}
          </div>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="bg-grey-lighten-5">
      <v-container
        fluid
        class="px-8"
        style="min-height: calc(var(--vh, 1vh) * 100)"
      >
        <v-row>
          <BreadcrumsBelajarWajib />
          <NuxtPage />
        </v-row>
      </v-container>
    </v-main>
  </v-layout>
</template>
<script>
import BreadcrumsBelajarWajib from "~/components/pembelajaran_wajib/shared/BreadcrumsBelajarWajib";
import AccountBelajarWajib from "~/components/pembelajaran_wajib/shared/AccountBelajarWajib";

export default {
  components: {
    BreadcrumsBelajarWajib,
    AccountBelajarWajib,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    isNavbarActive() {
      return Object.keys(useRoute().params).length > 0;
    },
    navbarLink() {
      const type = localStorage.getItem("courseType");
      const data = [];
      data.push(type);
      const link = [];
      for (let i = 0; i < data.length; i++) {
        const materi = {
          name: `Materi Swajar ${data[i]}`,
          to: `/pembelajaran-wajib/swajar-${data[i]}`,
          icon: "mdi-book-open-page-variant",
        };
        const jurnal = {
          name: `Jurnal  ${data[i]}`,
          to: `/pembelajaran-wajib/swajar-${data[i]}/jurnal`,
          icon: "mdi-notebook",
        };
        const evaluasiSatu = {
          name: "Evaluasi Akademik 1",
          to: `/pembelajaran-wajib/swajar-${data[i]}/evaluasi-akademik-1`,
          icon: "mdi-clipboard-text-clock",
        };
        const evaluasiDua = {
          name: "Evaluasi Akademik 2",
          to: `/pembelajaran-wajib/swajar-${data[i]}/evaluasi-akademik-2`,
          icon: "mdi-clipboard-text",
        };
        const profil = {
          name: "Profil Peserta",
          to: `/pembelajaran-wajib/swajar-${data[i]}/profil`,
          icon: "mdi-account",
        };
        const microlearning = {
          name: "Microlearning",
          to: `/pembelajaran-wajib/swajar-${data[i]}/microlearning`,
          icon: "mdi-book-open-variant",
        };
        const pusatBantuan = {
          name: "Pusat Bantuan",
          to: `/pusat-bantuan`,
          icon: "mdi-face-agent",
        };
        if (type !== "MOT") {
          link.push(materi);
          if (type !== "TOC") {
            link.push(microlearning);
          }
          if (type !== "CPNS") {
            link.push(jurnal);
          }
          link.push(evaluasiSatu, profil, pusatBantuan);
        } else {
          link.push(materi, evaluasiSatu, evaluasiDua, profil, pusatBantuan);
        }
      }
      return link;
    },
  },
  methods: {
    logoutBelajarWajib() {
      useBelajarWajibStore().clearTokens();
      return navigateTo({ path: "/pembelajaran-wajib/login" });
    },
  },
};
</script>
